

export class LocalAsyncStorage {
    getItem(key: string): Promise<string | null> {
        throw new Error('Method not implemented.')
    }
    setItem(key: string, value: string): Promise<void> {
        throw new Error('Method not implemented.')
    }
    removeItem(key: string): Promise<void> {
        throw new Error('Method not implemented.')
    }
    clear(): Promise<void> {
        throw new Error('Method not implemented.')
    }
    getObject<T,>(key: string, defaultValue: T): Promise<T> {
        throw new Error('Method not implemented.')
    }
    setObject<T,>(key: string, obj: T): Promise<void> {
        throw new Error('Method not implemented.')
    }
    length(): Promise<number> {
        throw new Error('Method not implemented.')
    }
    list(): Promise<void> {
        throw new Error('Method not implemented.')
    }
}
